import { FunctionComponent } from 'react';
import { NavLink } from 'react-router';

type Props = {
    available?: boolean;
    path: string;
    notificationCount?: number;
    children?: React.ReactNode;
};

const MenuItem: FunctionComponent<Props> = ({ notificationCount = 0, path, children, available = true }) => {
    if (!available) {
        return null;
    }

    return (
        <li>
            <NavLink to={path} className="menu__item">
                {children}
                {notificationCount > 0 && <span className="menu__badge">{notificationCount}</span>}
            </NavLink>
        </li>
    );
};

export default MenuItem;
